
// 获取年月
export const diffDate = (date1, date2) => {

  let begin = new Date(date1);
  let end = date2 ? new Date(date2) : new Date();
  // 如果开始时间晚于结束时间，交换日期，并记录交换状态
  let swap = false;
  if (begin > end) {
    let tmp = begin;
    begin = end;
    end = tmp;
    swap = true;
  }

  // 分别取二个日期的年、月、日值
  let d1 = begin.getDate();
  let m1 = begin.getMonth() + 1;
  let y1 = begin.getFullYear();
  let d2 = end.getDate();
  let m2 = end.getMonth() + 1;
  let y2 = end.getFullYear();

  // 获取每个月的天数，这里要注意一下闰年的2月
  var getMonthDays = function (y, m) {
    var aMonthDays = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (m == 2 && (y % 400 == 0 || (y % 4 == 0 && y % 100 != 0))) {
      return 29;
    }
    return aMonthDays[m];
  };

  let y, m, d;
  let tmpM = 0;
  let tmpY = 0;

  // 计算日，不足时向月份借
  if (d2 >= d1) {
    d = d2 - d1;
  } else {
    tmpM = -1;
    d = getMonthDays(y1, m1) + d2 - d1;
  }

  // 计算月，不足时向年份借
  if (m2 + tmpM >= m1) {
    m = m2 + tmpM - m1;
  } else {
    tmpY = -1;
    m = 12 + m2 + tmpM - m1;
  }

  // 计算年
  y = y2 + tmpY - y1;

  // 拼接距离字符串 输出格式如："5天"， "5月 05天"， "5年 05月 05日"


  // 完整输出
  return y
}

// 获取 性别
export const getSex = (id) => {
  var sexNum = id.charAt(id.length - 2)
  if (sexNum % 2 == 0) {
    return '女'
  } else {
    return '男'
  }
}


export const getIdYear = (id) => {
  return new Promise((resolve, roject) => {
    var date = id.substring(6, 14); // 截取生日
    var time = `${date.substring(0, 4)}-${date.substring(
      4,
      6
    )}-${date.substring(6, 14)}`;
    var age = diffDate(time)
    var sex = getSex(id)
    if (age || sex) {
      resolve({ age, sex })

    } else {
      roject('error')
    }
  })


}

export function dateAddYear(date, years) {
  var now = new Date(date);
  var intYear = now.getFullYear() + parseInt(years);
  var intMonth = now.getMonth() + 1; //正常的月份，
  var intDay = now.getDate(); //日期-1
  if (intDay == 0) {
    intMonth--; //减少一个月
    if (intMonth == 0) {
      intYear--; //0:减少一年
      intMonth = 12;
      intDay = 31;
    }
    else if (intMonth == 4 || intMonth == 6 || intMonth == 9 || intMonth == 11) {
      intDay = 30; //4,6,9,11:30天
    }
    else if (intMonth == 2) {
      intDay = 28; //2:28/29
      if (intYear % 4 == 0) {
        intDay = 29;
      }
    } else {
      intDay = 31; //1,3,5,7,8,10,12 :31天
    }
  }

  var strMonth = (intMonth) < 10 ? "0" + (intMonth).toString() : (intMonth).toString();
  var strDay = (intDay) < 10 ? "0" + (intDay).toString() : (intDay).toString();
  var strEndDate = intYear + "-" + strMonth + "-" + strDay;
  return strEndDate;
}